export const OTP_LENGTH = 6;

/**
 * Where a digit typed into an already-filled OTP box (1-based index) goes.
 * The user has usually backspaced back onto a filled box and kept typing, so
 * the digit belongs in the next box rather than replacing the current one.
 * On the last box there is nowhere to go, so it is replaced and submitted.
 */
export const otpDigitTarget = (fieldIndex: number) => {
  const writeTo = Math.min(fieldIndex + 1, OTP_LENGTH);
  return {
    writeTo,
    focusTo: Math.min(writeTo + 1, OTP_LENGTH),
    submit: writeTo === OTP_LENGTH,
  };
};
